import { useContext } from 'react';

import { ActionContext } from './ActionContext';

export const useActionContext = () => {
  const { location } = useContext(ActionContext);
  return { location };
};
